import React, { useState } from 'react';
import { Box, Container, Stack, Tabs, Tab } from '@mui/material';

import { Page } from '../../../components';
import HeaderBreadcrumbs from '../../../components/header-breadcrumbs';
import { AuditLogExplorer, RawSqlConsole } from '../../../components/audit-log-explorer';
import { ALE } from '../../../components/audit-log-explorer/tokens';

const title = 'POM - Audit Log Explorer';
const heading = 'Audit Log Explorer';

export const AuditLogExplorerScreen: React.FC = () => {
    const [tab, setTab] = useState(0);

    return (
        <Page title={title}>
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading={heading}
                        links={[{ name: 'Explore API audit logs across services', href: '/audit-log-explorer' }]}
                        activeLast={false}
                    />
                </Stack>

                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                    sx={{ borderBottom: `1px solid ${ALE.border}`, mt: 1, '& .MuiTabs-indicator': { backgroundColor: ALE.pMain } }}
                >
                    <Tab disableRipple label="Filtered Search" sx={{ textTransform: 'none', fontWeight: 600, fontSize: 14, color: ALE.tMuted, '&.Mui-selected': { color: ALE.pMain } }} />
                    <Tab disableRipple label="Raw SQL" sx={{ textTransform: 'none', fontWeight: 600, fontSize: 14, color: ALE.tMuted, '&.Mui-selected': { color: ALE.pMain } }} />
                </Tabs>

                {/* Both stay mounted so each tab's state (especially the SQL console's
                    query + results) survives switching. `active` lets the hidden tab
                    close its detail drawer — the drawer is a body-portal, so it would
                    otherwise overlay the visible tab. */}
                <Box sx={{ display: tab === 0 ? 'block' : 'none' }}>
                    <AuditLogExplorer active={tab === 0} />
                </Box>
                <Box sx={{ display: tab === 1 ? 'block' : 'none' }}>
                    <RawSqlConsole active={tab === 1} />
                </Box>
            </Container>
        </Page>
    );
};
